import { render, staticRenderFns } from "./MasterDataDriverCompany.vue?vue&type=template&id=454daf34&scoped=true"
import script from "./MasterDataDriverCompany.vue?vue&type=script&lang=js"
export * from "./MasterDataDriverCompany.vue?vue&type=script&lang=js"
import style0 from "./MasterDataDriverCompany.vue?vue&type=style&index=0&id=454daf34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "454daf34",
  null
  
)

export default component.exports